import ox from '$/ox'
import $ from '$/jquery'

const _avp = window._avp = window._avp || []
let cmpReady = false

export function pushAd (tags = []) {
  tags.forEach(function (t) { _avp.push(JSON.parse(t)) })
}

export function openManageCookies () {
  if (!window._sp_?.gdpr?.loadPrivacyManagerModal) return
  try {
    window._sp_.gdpr.loadPrivacyManagerModal('959575')
  } catch (e) {
    console.log('Not able to load Consent Manager dialog')
  }
}

// Set CMP ready (consent data available)
// Then run queud ads
function setCmpReady () {
  cmpReady = true
  // Load pending ads
  if (window.AVP && window.AVP.load) {
    window.AVP.load()
  }
}

// Get CMP ready (consent data available)
export function getCmpReady () {
  return cmpReady
}

let tradehouseScriptLoaded = false
export const loadCmpScript = function () {
  if (tradehouseScriptLoaded) return
  tradehouseScriptLoaded = true

  if (!ox.serverConfig.faktorURL) return

  window._sp_queue = window._sp_queue || []
  window._sp_queue.push(function () {
    window._sp_.addEventListener('onConsentReady', setCmpReady)
  })

  $('head').prepend(
    $('<script>').attr({
      type: 'text/javascript',
      async: true,
      /* https://tradecore.tradehouse.media/js/talktalk.js */
      src: ox.serverConfig.faktorURL
    })
  )
  /* Not working as TH script expects script yo be in the head
  $.getScript('https://tradecore.tradehouse.media/js/talktalk.js')
  */
}

export default {
  loadCmpScript,
  getCmpReady,
  openManageCookies,
  pushAd
}
